function addNameAndNumber() {
  console.log("Adicionando Div!");
  observer.disconnect(); // Evita loop
  document.querySelector("#aparecer")?.classList.remove("removeContainerPersonalizar");
  observer.observe(targetNode, config); // Reativa observação
}

function removeNameAndNumber() {
  console.log("Removendo div!");
  observer.disconnect();
  document.querySelector("#aparecer")?.classList.add("removeContainerPersonalizar");
  observer.observe(targetNode, config);
}

const targetNode = document.querySelector(".product-information");
const config = { attributes: true, childList: true, subtree: true };

const monitorCustomize = (mutationList, observer) => {
  // Verifica sempre o select da personalização
  const selectPersonalizar = document.querySelector('select[name="options[2]"]');
  if (selectPersonalizar) {
    const value = selectPersonalizar.value.trim().toLowerCase();
    console.log("Valor atual Personalizar:", value);

    if (value === "personalizar") {
      addNameAndNumber();
    } else {
      removeNameAndNumber();
    }

    // Garante também que a cada troca de valor chama a função
    selectPersonalizar.removeEventListener("change", monitorCustomize);
    selectPersonalizar.addEventListener("change", monitorCustomize);
  }
};

const observer = new MutationObserver(monitorCustomize);
if (targetNode) {
  observer.observe(targetNode, config);
}

// Garante que no carregamento inicial já roda
monitorCustomize();

document.addEventListener("submit", function (event) {
  const form = event.target.closest("form[action*='/cart/add']");
  if (!form) return;

  const nomeInput = document.querySelector("input[name='properties[Nome]']");
  const numeroInput = document.querySelector("input[name='properties[Número]']");

  if (nomeInput && numeroInput) {
    if (!nomeInput.value.trim() && !numeroInput.value.trim()) return;

    let hiddenNome = document.createElement("input");
    hiddenNome.type = "hidden";
    hiddenNome.name = "properties[Nome]";
    hiddenNome.value = nomeInput.value;

    let hiddenNumero = document.createElement("input");
    hiddenNumero.type = "hidden";
    hiddenNumero.name = "properties[Número]";
    hiddenNumero.value = numeroInput.value;

    form.appendChild(hiddenNome);
    form.appendChild(hiddenNumero);
  }
}, true);
